import { normalizeBoolean } from '@change-corgi/config/fcm/normalizers';

import { createFcmConfig } from '../shared/factory';

export const FCM_PETITION_DISPLAY_RECRUITER_NAME = createFcmConfig('petition_display_recruiter_name', {
	normalizer: normalizeBoolean,
	defaultValue: false,
});
